import 'sass/app.scss';

import _ from 'lodash';
import React, { useState } from 'react';
import { wrapGrid } from 'client/shared/util';
import { observer, inject } from 'mobx-react';
import { ToastContainer } from 'react-toastify';
import {
	HashRouter as Router,
	Route,
	NavLink,
	Redirect,
	Switch,
} from 'react-router-dom';


import Album from './album';
import Browse from './browse';
import Artist from './artist';
import Search from './search';
import MyMusic from './my-music';
import MusicPlayer from './music-player';
import ProfileImage from './profile-image';
import Account from './account';

import FAQS from './faqs';

const LinkItem = inject('routingStore')(({routingStore, activeSlug, label, to }) => {
	const { location: { hash = '' }} = routingStore;
	const [active, setActive] = useState(hash.replace(/#\/([^/]+)\/.+/, '$1'));

	return (
		<NavLink
			className={ `header-link ${activeSlug === label ? 'active' : ''}` }
			onClick={ () => { setActive(activeSlug) } }
			exact to={ to }
		>
			{ label }
		</NavLink>
	)
});

const MembersPage = inject('userStore')((observer(({ userStore }) => {
	const member = userStore.getLoggedInUser();
	
	let isDev = import.meta.env.MODE !== 'production' && import.meta.env.MODE !== 'int';
	return (
		<div className="members main-container gradient-bg" data-ta="member-main-container">
			<div className="grid-x">
				<div className="cell small-12">
					<div className="topNavbar">
						<div style={{display:"flex", alignItems:"center"}}>
							<div className="logo-small header"></div>
							{/*Routes are placeholder for now */}
							<ul className="menu" style={{justifyContent:'end'}}>
								<li className="icon-menu"><LinkItem label="Home" activeSlug="home" to="/browse/featured-artists" /></li>
								<li className="icon-menu"><LinkItem label="Search" activeSlug="search" to="/search" /></li>
								<li className="icon-menu"><LinkItem label="My Music" activeSlug="my-music" to="/my-music" /></li>
							</ul>
						</div>
						
						<Switch>
							<Route path={isDev ? "/account" : "/#/account"}>
								<div id="placeholder"></div>
							</Route>
							<Route path={isDev ? "/faqs" : "/#/faqs"}>
								<div id="placeholder"></div>
							</Route>
						</Switch>
						
						<div className = "memberInfo primary-font" data-ta="member-info">
							<ProfileImage member={member}/>
						</div>
					</div>
					
					<div className="mainFeatureContainer">
						<div className="cell auto">
							<div className="membersRootBg">
									<div>
										<Route exact path="/" render={() => ( <Redirect to="/browse/featured-artists" /> )}/>
										<Route path="/account" component={ wrapGrid(Account, {minHeight: '90vh'}) } />
										<Route path="/faqs" component={ wrapGrid(FAQS, {minHeight: '81vh'}) } />
										<Route path="/my-music" component={ wrapGrid(MyMusic, {minHeight: '81vh'}) } />
										<Route path="/artist/:id/" component={ wrapGrid(Artist) }/>
										<Route path="/album/:id" component={ wrapGrid(Album) } />
										<Route path="/browse" component={ wrapGrid(Browse) } />
										<Route path="/search" component={ wrapGrid(Search, {minHeight: '81vh'}) } />
									</div>
							</div>
						</div>
					</div>
				</div>
				<Switch>
					<Route path="/account">
					</Route>
					<Route path="/faqs">
						{/* <Footer></Footer> */}
					</Route>
					<Route>

					</Route>
				</Switch>
			</div>
			<div className="grid-x">
				<div className="cell">
					<footer style={{zIndex: 20}}>
						<Switch>
							<Route path="/account">

							</Route>
							<Route>
								<MusicPlayer />
							</Route>
						</Switch>
					</footer>
				</div>
			</div>
			<div style={{position: 'absolute', top: '0', right: '0'}}>
				<ToastContainer />
			</div>
		</div>
	);
})))

export default observer(({}) => {
	const [showArrows] = useState(false);
	const [recentList, setRecentList] = useState(localStorage.getItem('recentList'));

	window.addEventListener('recentAdded', (updateData) => {
		setRecentList({recentList: updateData });
	});

	return (
		<Router>
			<MembersPage 
				showArrows={showArrows} 
				recentList={recentList}

			/>
		</Router>
	);
});
	


